const SCROLL_END_TOLERANCE_PX = 1;

interface ScrollMetrics {
  scrollLeft: number;
  clientWidth: number;
  scrollWidth: number;
}

/** Whether the container can still scroll left/right, with a sub-pixel tolerance for fractional zoom levels */
export function getScrollState({
  scrollLeft,
  clientWidth,
  scrollWidth
}: ScrollMetrics): { canScrollLeft: boolean; canScrollRight: boolean } {
  const maxScrollLeft = scrollWidth - clientWidth;

  return {
    canScrollLeft: scrollLeft > SCROLL_END_TOLERANCE_PX,
    canScrollRight: maxScrollLeft - scrollLeft > SCROLL_END_TOLERANCE_PX
  };
}
